import _ from 'lodash';

import { DOC_FIELD_TYPES, TagColorByDocType } from 'constants/documentFieldTypes';

export const createDocumentFieldTypesPath = (documentFieldTypes, fieldType) => {
  let currentFieldType = fieldType;
  const path = [fieldType.name];

  while (documentFieldTypes[currentFieldType.parentId]) {
    currentFieldType = documentFieldTypes[currentFieldType.parentId];
    path.push(currentFieldType.name);
  }

  return path.reverse().join(' ');
};

export const getTagColorByDocumentFieldType = (type, theme) => {
  const textColor =
    type === DOC_FIELD_TYPES.INTEGER ? theme.palette.common.black : theme.palette.common.white;

  return {
    backgroundColor: _.get(theme, ['tag', TagColorByDocType[type]]),
    color: textColor,
  };
};

/**
 * Returns boolean if current type is CONTAINER or TABLE
 * @example
 * checkIsContainerType(DOC_FIELD_TYPES.CONTAINER)
 * // returns true
 * checkIsContainerType(DOC_FIELD_TYPES.INTEGER)
 * // returns false
 * @param {typeof DOC_FIELD_TYPES} type
 * @returns {boolean}
 */
export const checkIsContainerType = type =>
  type === DOC_FIELD_TYPES.CONTAINER || type === DOC_FIELD_TYPES.TABLE;

/**
 * Returns object of DOC_FIELD_TYPES in {name, value} structure filtered by excluded types
 * @param {Array<typeof DOC_FIELD_TYPES>} typesToExclude Array of DOC_FIELD_TYPES that shouldn't be included in DocumentFieldTypeOptions
 * @returns Array<{name: string, value: typeof DOC_FIELD_TYPES}>
 *
 * @example
 * getFilteredDocumentFieldTypeOptions()
 * // returns [{
 *         name: Bool,
 *         value: BOOL,
 *       }, {
 *         name: Container,
 *         value: CONTAINER,
 *       }, {
 *         name: Dynamic Container,
 *         value: TABLE,
 *       }, ...]
 * getFilteredDocumentFieldTypeOptions([DOC_FIELD_TYPES.CONTAINER])
 * // returns [{
 *         name: Bool,
 *         value: BOOL,
 *       }, {
 *         name: Dynamic Container,
 *         value: TABLE,
 *       }, ...]
 */
export const getFilteredDocumentFieldTypeOptions = typesToExclude =>
  Object.values(DOC_FIELD_TYPES).reduce((acc, type) => {
    const isTypeExcluded = typesToExclude?.includes(type);

    if (!isTypeExcluded) {
      acc.push({
        name: _.startCase(type),
        value: type,
      });
    }

    return acc;
  }, []);

export const getOptionFieldTypeFromOption = ({ parentId, name }) => ({
  id: _.uniqueId(),
  name,
  parentId,
  typeDefinition: {
    type: DOC_FIELD_TYPES.DROP_DOWN_FIELD,
  },
});
